module.exports = __webpack_public_path__ + "img/Weapon_209.a2849648.png";